import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Datetime from 'react-datetime';

import withStyles from '@material-ui/core/styles/withStyles';

import {
  Container, EditButton, HoverText, Text, style,
} from './style';

class EditTime extends Component {
  state = {
    active: false,
    hover : false,
  };

  onClick = () => {
    this.setState({ active: true });
  };

  onInputBlur = (date) => {
    const { onChange } = this.props;
    onChange(date);
    this.setState({ active: false, hover: false });
  };

  onMouseEnter = () => {
    this.setState({ hover: true });
  };

  onMouseLeave = () => {
    this.setState({ hover: false });
  };

  render() {
    const {
      children, classes, date, editable, timezone,
    } = this.props;
    const { active, hover } = this.state;

    return (
      <Container>
        {editable && active && (
          <Datetime
            dateFormat={false}
            timeFormat="HH:mm"
            defaultValue={moment(date)}
            displayTimeZone={timezone}
            inputProps={{
              className  : classes.input,
              placeholder: 'Pickup Time',
              onKeyDown  : e => e.preventDefault(),
              onChange   : e => e.preventDefault(),
            }}
            onBlur={this.onInputBlur}
          />
        )}
        {editable && !active && (
          <HoverText
            onClick={this.onClick}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
          >
            {children}
            {hover && <EditButton />}
          </HoverText>
        )}
        {!editable && (
          <Text>
            {children}
          </Text>
        )}
      </Container>
    );
  }
}
EditTime.propTypes = {
  classes : PropTypes.shape({}).isRequired,
  children: PropTypes.node,
  date    : PropTypes.string,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
  timezone: PropTypes.string,
};
EditTime.defaultProps = {
  children: null,
  date    : null,
  editable: true,
  onChange() {},
  timezone: 'Europe/Madrid',
};

export default withStyles(style)(EditTime);
